class Animations {
  constructor() {
    this.events();
  }

  events() {
    window.addEventListener("scroll", () => this.reveal());
    this.fixRevealRight(); // Call the new method here
  }

  reveal() {
    let reveals = document.querySelectorAll(".reveal");
    reveals.forEach((el) => {
      let windowHeight = window.innerHeight;
      let elementTop = el.getBoundingClientRect().top;
      let elementVisible = 200;
      if (elementTop < windowHeight - elementVisible) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  }

  // New method to fix '.reveal.right' elements
  fixRevealRight() {
    const revealRightElements = document.querySelectorAll('.reveal.right');
    revealRightElements.forEach((element) => {
      element.parentElement.style.overflow = 'hidden';
    });
  }
}

export default Animations;
